import * as revenueDetailsConstants from 'revenue/RevenueDetails/constants'

export const { REVENUE_SORT_COLUMNS } = revenueDetailsConstants
